import appSettings from 'wanderu-config';
import {
    selectLocale,
} from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { WapiService } from 'wanderu-service-wapi';

import { actions as tripDataActions } from '../../appstate';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-trips:fetchTripInformation');

export function fetchTripInformation(tripIds, selectedFares = {}) {
    return async (dispatch, getState) => {
        const selectorId = tripIds.join('');

        const hasFetched = selectors.selectSuccess(getState(), selectorId);
        const isFetching = selectors.selectWorking(getState(), selectorId);
        if (hasFetched || isFetching) {
            return;
        }

        dispatch(actions.startWork(selectorId));

        let error;
        try {
            const locale = selectLocale(getState());

            const tripInfo = {
                locale,
                tripIds,
            };

            if (Object.keys(selectedFares).length) {
                tripInfo.selectedFares = selectedFares;
            }

            const { result } = await WapiService.getTripInformation(tripInfo);

            return await Promise.all(Object.keys(result).map(async (tripId) => {
                const {
                    fareTitle,
                    termsAndConditions,
                } = result[tripId];
                const tripInfoObj = {
                    fareTitle: fareTitle.value,
                    termsAndConditions: termsAndConditions.value,
                };

                await dispatch(tripDataActions.setTripInformation(tripId, tripInfoObj));
            }));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetchTripInformation', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(selectorId, undefined, error));
        }
    };
}

const fetchTripInformationAction = {
    fetchTripInformation,
    ...selectors,
};

export {
    fetchTripInformationAction,
};

export default {
    [namespace]: reducer,
};
